import React, { useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../ui/sheet';
import { Sparkle } from '@phosphor-icons/react';
import AgentChat from './AgentChat';

/** Floating assistant button available on every page for office staff. */
const AssistantFab = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)} className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 flex items-center justify-center hover:scale-105 active:scale-95 transition-transform" aria-label="Open AI assistant" data-testid="assistant-fab">
        <Sparkle weight="fill" className="w-6 h-6" />
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full sm:max-w-xl p-0 flex flex-col" data-testid="assistant-sheet">
          <SheetHeader className="px-4 pt-4 pb-2"><SheetTitle className="font-heading">AI Assistant</SheetTitle><SheetDescription>Ask for schedule changes, lookups, billing — confirm before anything changes.</SheetDescription></SheetHeader>
          <div className="flex-1 min-h-0 px-4 pb-4"><AgentChat compact /></div>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default AssistantFab;
